import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import * as keymapService from './services/keymapService/keymapService'
import './directives'
import './autoRefresh'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import { KEY_CODES } from '@/constants/keyCodes'
import * as matomo from './analytics/matomo'
import * as posthog from './analytics/posthog'

window.north = {
  searchResults: {},
  printSearchResults() {
    console.log(
      JSON.stringify(
        this.searchResults,
        ['goals', 'krs', 'initiatives', 'comments', 'id', 'title', 'tsRank', 'tsId', 'isClosed'],
        2
      )
    )
  }
}

keymapService.enable()

Vue.config.productionTip = false
Vue.config.keyCodes = KEY_CODES
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

if (process.env['VUE_APP_ENABLE_SENTRY']) {
  let environment = process.env['VUE_APP_ENVIRONMENT'] || 'dev'
  Sentry.init({
    Vue,
    dsn: 'https://7fe9614e97f847de8a41ee1135f34d87@o407058.ingest.sentry.io/5288606',
    attachProps: true,
    logErrors: true,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracePropagationTargets: ['localhost', 'to.thenorth.io', /^\//]
      })
    ],
    environment: environment,
    tracesSampleRate: 0.1
  })
  if (store.getters.user) {
    let user = store.getters.user
    Sentry.setUser({ id: user.id, username: user.fullName })
  }
  store.subscribe(mutation => {
    if (mutation.type === 'SET_CURRENT_USER') {
      let user = mutation.payload.user
      if (user) {
        Sentry.setUser({ id: user.id, username: user.fullName })
      } else {
        Sentry.setUser(null)
      }
    }
  })
}

const MATOMO_SITE_ID = process.env['VUE_APP_MATOMO_SITE_ID']
const MATOMO_COOKIE_DOMAIN = process.env['VUE_APP_MATOMO_COOKIE_DOMAIN']

console.log('MATOMO_SITE_ID', MATOMO_SITE_ID)
console.log('MATOMO_COOKIE_DOMAIN', MATOMO_COOKIE_DOMAIN)

if (MATOMO_SITE_ID) {
  matomo.enable(
    MATOMO_SITE_ID,
    MATOMO_COOKIE_DOMAIN,
    process.env['VUE_APP_MATOMO_DIMENSION_VISIT_MEDIUM_ID'],
    process.env['VUE_APP_MATOMO_DIMENSION_ACTION_MEDIUM_ID']
  )
}

const POSTHOG_API_KEY = process.env['VUE_APP_POSTHOG_API_KEY']
const POSTHOG_API_HOST = process.env['VUE_APP_POSTHOG_API_HOST'] || 'https://app.posthog.com'
console.log('POSTHOG setup', POSTHOG_API_HOST, POSTHOG_API_KEY)

if (POSTHOG_API_KEY) {
  posthog.enable(POSTHOG_API_HOST, POSTHOG_API_KEY)
}
